import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { ProjectProvider, IntentsProvider, LoadingProvider, ValidProvider, msalConfig } from './lib'
import 'material-icons/iconfont/material-icons.css';
import './styles/main.scss'
import './styles/responsive.css'
import { CookiesProvider } from 'react-cookie';
import 'animate.css';
const msalInstance = new PublicClientApplication(msalConfig)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <MsalProvider instance={msalInstance}>
      <CookiesProvider>
        <ProjectProvider>
          <ValidProvider>
            <LoadingProvider>
              <IntentsProvider>
                <App />
              </IntentsProvider>
            </LoadingProvider>
          </ValidProvider>
        </ProjectProvider>
      </CookiesProvider>
    </MsalProvider>
  </React.StrictMode> 
)
